export const READER_TRANSACTION_SUCCESS = 'terminal/READER_TRANSACTION_SUCCESS';
export const READER_TRANSACTION_FAIL = 'terminal/READER_TRANSACTION_FAIL';
export const STRIPE_CONNECT_TOKEN = 'terminal/STRIPE_CONNECT_TOKEN';
export const COLLECT_PAYMENT_METHOD_SUCCESS = 'terminal/COLLECT_PAYMENT_METHOD_SUCCESS';
export const PROCESS_PAYMENT_SUCCESS = 'terminal/PROCESS_PAYMENT_SUCCESS';
export const CANCEL_TRANSACTION = 'terminal/CANCEL_TRANSACTION';
export const WEBREADER_ERROR = 'terminal/WEBREADER_ERROR';
export const READER_REFUND_FAIL = 'terminal/READER_REFUND_FAIL';
export const READER_REFUND_SUCCESS = 'terminal/READER_REFUND_SUCCESS';
export const CAPTURE_REFUND = 'terminal/CAPTURE_REFUND';
